import React from 'react';
import { Link } from 'react-router-dom';
import useLogout from '../../hooks/useLogout';
import Loader from '../Loader';
import { amountDisplay } from '../../util/helper';
import { useLanguage } from '../../context/LanguageContext';

function Sidebar({ summary, handleDarkModeToggle, isDarkMode }) {
    const { handleLogout, loading } = useLogout();
    const { t, language } = useLanguage();

    return (
        <>
            <Loader loading={loading} />

            <div
                className="offcanvas sidebar-offcanvas offcanvas-start"
                tabIndex="-1"
                id="offcanvasLeft"
            >
                <div className="offcanvas-header sidebar-header">
                    <div className="sidebar-logo">
                        <img
                            className="img-fluid logo"
                            src={'assets/images/logo/coin.png'}
                            alt="logo"
                        />
                        <span className={'sidebar-title'}>Xpenso</span>
                    </div>
                    <div className="balance">
                        <img
                            className="img-fluid balance-bg"
                            src={'assets/images/background/auth-bg.jpg'}
                            alt="auth-bg"
                        />
                        <h5>{t('balance')}</h5>
                        <h2>{amountDisplay(summary?.totalBalance, language)}</h2>
                    </div>
                </div>
                <div className="offcanvas-body">
                    <div className="sidebar-content">
                        <ul className="link-section">
                            <li>
                                <a href="/" className="pages">
                                    <img
                                        className="active"
                                        src={'assets/images/svg/home-icon.svg'}
                                        alt="Xpenso"
                                    />
                                    <h3>{t('home')}</h3>
                                </a>
                            </li>
                            <li>
                                <Link
                                    to="/accounts"
                                    onClick={() => {
                                        document.body.classList.remove(
                                            'offcanvas-backdrop',
                                            'show'
                                        );
                                        document
                                            .querySelectorAll('.offcanvas-backdrop')
                                            .forEach((el) => el.remove());
                                    }}
                                    className="pages"
                                >
                                    <img
                                        className="sidebar-icon transaction-icon"
                                        src={'assets/images/svg/sidebar-accounts.svg'}
                                        alt="Xpenso"
                                    />
                                    <h3>{t('accounts')}</h3>
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/cards"
                                    onClick={() => {
                                        document.body.classList.remove(
                                            'offcanvas-backdrop',
                                            'show'
                                        );
                                        document
                                            .querySelectorAll('.offcanvas-backdrop')
                                            .forEach((el) => el.remove());
                                    }}
                                    className="pages"
                                >
                                    <img
                                        className="sidebar-icon transaction-icon"
                                        src={'assets/images/svg/sidebar-cards.svg'}
                                        alt="Xpenso"
                                    />
                                    <h3>{t('cards')}</h3>
                                </Link>
                            </li>
                            <li>
                                <a href="/profile" className="pages">
                                    <img
                                        className="sidebar-icon transaction-icon"
                                        src={'assets/images/svg/sidebar-profile.svg'}
                                        alt="Xpenso"
                                    />
                                    <h3>{t('profile')}</h3>
                                </a>
                            </li>
                            <li>
                                <Link className="pages" to="#" onClick={handleLogout}>
                                    <i className="sidebar-icon" data-feather="log-out"></i>
                                    <h3>{t('logOut')}</h3>
                                </Link>
                            </li>
                        </ul>
                        <div className="mode-switch">
                            <ul className="switch-section">
                                <li>
                                    <h3>{t('dark')}</h3>
                                    <div className="switch-btn">
                                        <input
                                            id="dark-switch"
                                            type="checkbox"
                                            checked={isDarkMode}
                                            onChange={handleDarkModeToggle}
                                        />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Sidebar;
